// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bce_a bhn_ke","ListItemIcon--empty":"bce_b bhn_fl"};